import { collection, query, where, doc, getDoc, orderBy } from 'firebase/firestore';
import { db } from '../config';
import { getDocsOnline } from './getDocsOnline';
import type { FirestorePlaceDoc } from '../../types/place';

const COLLECTION_NAME = 'collections';

/**
 * Find root-level spaces (no parent) for a site, ordered.
 */
export async function findRootSpaces(siteId: string): Promise<FirestorePlaceDoc[]> {
  const q = query(
    collection(db!, COLLECTION_NAME),
    where('appId', '==', siteId),
    where('parentId', '==', null),
    orderBy('order')
  );
  const snapshot = await getDocsOnline(q);
  const spaces = snapshot.docs.map(d => ({ id: d.id, ...d.data() } as FirestorePlaceDoc));
  const mainRoot = spaces.find(s => s.isMainRoot === true);
  if (mainRoot) {
    return [mainRoot, ...spaces.filter(s => s.id !== mainRoot.id)];
  }
  return spaces;
}

/**
 * Find child spaces of a parent space, ordered.
 */
export async function findChildSpaces(parentId: string): Promise<FirestorePlaceDoc[]> {
  const q = query(
    collection(db!, COLLECTION_NAME),
    where('parentId', '==', parentId),
    orderBy('order')
  );
  const snapshot = await getDocsOnline(q);
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() } as FirestorePlaceDoc));
}

/**
 * Get a single space by ID.
 */
export async function findSpaceById(spaceId: string): Promise<FirestorePlaceDoc | null> {
  const docRef = doc(db!, COLLECTION_NAME, spaceId);
  const docSnap = await getDoc(docRef);
  if (!docSnap.exists()) return null;
  return { id: docSnap.id, ...docSnap.data() } as FirestorePlaceDoc;
}
